import React, { useState } from 'react';

const DEMO_SOPS = [
  { id: 1, title: 'Equipment Inspection Procedure', category: 'Safety', version: 'v2.1', updated: '2026-01-15', status: 'Active' },
  { id: 2, title: 'Chemical Handling & Storage', category: 'Hazmat', version: 'v1.4', updated: '2026-01-20', status: 'Active' },
  { id: 3, title: 'Emergency Response Protocol', category: 'Safety', version: 'v3.0', updated: '2025-12-01', status: 'Active' },
  { id: 4, title: 'Vehicle Pre-Trip Checklist', category: 'Transport', version: 'v1.2', updated: '2026-02-01', status: 'Active' },
  { id: 5, title: 'Personal Protective Equipment Guide', category: 'Safety', version: 'v2.0', updated: '2025-11-15', status: 'Under Review' },
];

const DEMO_JHAS = [
  { id: 1, title: 'Confined Space Entry', risk: 'High', lastReview: '2026-01-28', controls: 4 },
  { id: 2, title: 'Working at Heights', risk: 'High', lastReview: '2026-02-02', controls: 5 },
  { id: 3, title: 'Hot Work Operations', risk: 'Medium', lastReview: '2026-01-10', controls: 3 },
];

const RISK_COLORS = {
  High: { bg: 'rgba(239,68,68,0.15)', text: '#ef4444' },
  Medium: { bg: 'rgba(245,158,11,0.15)', text: '#f59e0b' },
  Low: { bg: 'rgba(16,185,129,0.15)', text: '#10b981' },
};

export default function CompliancePage() {
  const [sopSearch, setSopSearch] = useState('');

  const filteredSops = DEMO_SOPS.filter(s =>
    s.title.toLowerCase().includes(sopSearch.toLowerCase()) ||
    s.category.toLowerCase().includes(sopSearch.toLowerCase())
  );

  const safetyStats = [
    { label: 'Days Without Incident', value: '142', color: '#10b981', icon: '\u2705' },
    { label: 'Active SOPs', value: String(DEMO_SOPS.filter(s => s.status === 'Active').length), color: '#6366f1', icon: '\uD83D\uDCC4' },
    { label: 'Open JHAs', value: String(DEMO_JHAS.length), color: '#f59e0b', icon: '\u26A0\uFE0F' },
    { label: 'Compliance Score', value: '96%', color: '#10b981', icon: '\uD83C\uDFC6' },
  ];

  return (
    <div className="page-body" style={{ padding: 24 }}>
      <div className="page-header" style={{ marginBottom: 28 }}>
        <h1 className="page-title" style={{ color: 'var(--text)', fontSize: 26, fontWeight: 700, margin: '0 0 4px' }}>
          Safety &amp; Compliance
        </h1>
        <p className="page-subtitle" style={{ color: 'var(--text-muted)', fontSize: 14, margin: 0 }}>
          SOPs, Job Hazard Analyses, and safety metrics
        </p>
      </div>

      {/* Safety Stats */}
      <div className="stats-grid" style={{
        display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))',
        gap: 14, marginBottom: 28
      }}>
        {safetyStats.map((s, i) => (
          <div key={i} className="stat-card" style={{
            padding: 18, background: 'var(--card)', borderRadius: 12,
            border: '1px solid var(--border)', textAlign: 'center'
          }}>
            <div style={{ fontSize: 22, marginBottom: 6 }}>{s.icon}</div>
            <div className="stat-value" style={{ fontSize: 24, fontWeight: 700, color: s.color, marginBottom: 4 }}>
              {s.value}
            </div>
            <div className="stat-label" style={{ fontSize: 11, color: 'var(--text-muted)', textTransform: 'uppercase', fontWeight: 600 }}>
              {s.label}
            </div>
          </div>
        ))}
      </div>

      {/* SOP Library */}
      <div className="card" style={{
        padding: 24, background: 'var(--card)', borderRadius: 12,
        border: '1px solid var(--border)', marginBottom: 20
      }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
          <h2 className="card-title" style={{ color: 'var(--text)', fontSize: 17, fontWeight: 600, margin: 0 }}>
            SOP Library
          </h2>
          <input
            className="input"
            type="text"
            value={sopSearch}
            onChange={(e) => setSopSearch(e.target.value)}
            placeholder="Search SOPs..."
            style={{
              padding: '8px 14px', background: 'var(--bg)', border: '1px solid var(--border)',
              borderRadius: 8, color: 'var(--text)', fontSize: 13, outline: 'none', width: 220
            }}
          />
        </div>

        <div className="table-container" style={{ overflow: 'hidden', borderRadius: 8, border: '1px solid var(--border)' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr style={{ borderBottom: '1px solid var(--border)', background: 'var(--bg)' }}>
                {['Title', 'Category', 'Version', 'Updated', 'Status'].map(h => (
                  <th key={h} style={{
                    padding: '10px 14px', textAlign: 'left', fontSize: 11, fontWeight: 600,
                    textTransform: 'uppercase', letterSpacing: 0.5, color: 'var(--text-muted)'
                  }}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {filteredSops.map(sop => (
                <tr key={sop.id} style={{ borderBottom: '1px solid var(--border)' }}>
                  <td style={{ padding: '10px 14px', color: 'var(--text)', fontSize: 13, fontWeight: 500 }}>{sop.title}</td>
                  <td style={{ padding: '10px 14px' }}>
                    <span style={{
                      padding: '3px 10px', borderRadius: 10, fontSize: 11, fontWeight: 600,
                      background: 'rgba(99,102,241,0.15)', color: '#6366f1'
                    }}>{sop.category}</span>
                  </td>
                  <td style={{ padding: '10px 14px', color: 'var(--text-muted)', fontSize: 12 }}>{sop.version}</td>
                  <td style={{ padding: '10px 14px', color: 'var(--text-secondary)', fontSize: 12 }}>{sop.updated}</td>
                  <td style={{ padding: '10px 14px' }}>
                    <span style={{
                      padding: '3px 10px', borderRadius: 10, fontSize: 11, fontWeight: 600,
                      background: sop.status === 'Active' ? 'rgba(16,185,129,0.15)' : 'rgba(245,158,11,0.15)',
                      color: sop.status === 'Active' ? '#10b981' : '#f59e0b'
                    }}>{sop.status}</span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* JHA Section */}
      <div className="card" style={{
        padding: 24, background: 'var(--card)', borderRadius: 12,
        border: '1px solid var(--border)'
      }}>
        <h2 className="card-title" style={{ color: 'var(--text)', fontSize: 17, fontWeight: 600, margin: '0 0 16px' }}>
          Job Hazard Analyses (JHA)
        </h2>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))', gap: 14 }}>
          {DEMO_JHAS.map(jha => (
            <div key={jha.id} style={{
              padding: 18, background: 'var(--bg)', borderRadius: 10,
              border: '1px solid var(--border)'
            }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 10 }}>
                <h4 style={{ color: 'var(--text)', fontSize: 14, fontWeight: 600, margin: 0, flex: 1 }}>
                  {jha.title}
                </h4>
                <span style={{
                  padding: '3px 10px', borderRadius: 10, fontSize: 10, fontWeight: 700,
                  background: RISK_COLORS[jha.risk].bg, color: RISK_COLORS[jha.risk].text,
                  flexShrink: 0, marginLeft: 8
                }}>{jha.risk}</span>
              </div>
              <div style={{ color: 'var(--text-muted)', fontSize: 12, lineHeight: 1.8 }}>
                <div>Last Review: {jha.lastReview}</div>
                <div>Control Measures: {jha.controls}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
